// frontend/src/site/components/SiteFooter.jsx
import { useSite } from '../SiteContext';
import {
  headingClasses,
  mutedTextClasses,
  linkClasses,
  iconTone,
} from '../theme/siteStyles';

const cx = (...c) => c.filter(Boolean).join(' ');

function formatPhone(str) {
  const d = String(str || '').replace(/\D/g, '');
  if (!d) return '';
  const part = d.replace(/^55/, '');
  if (part.length >= 11)
    return `(${part.slice(0, 2)}) ${part.slice(2, 7)}-${part.slice(7, 11)}`;
  if (part.length >= 10)
    return `(${part.slice(0, 2)}) ${part.slice(2, 6)}-${part.slice(6, 10)}`;
  return part;
}

export default function SiteFooter() {
  const { perfilSite, ownerWhatsUrl, theme } = useSite();
  const wa = formatPhone(perfilSite?.whatsappDisplay);
  const siteHandle = perfilSite?.siteHandle || '';

  const icon = iconTone(theme);

  return (
    <footer className="border-t border-[color:var(--border)] bg-[color:var(--card)]">
      <div className="max-w-6xl mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          <div className="flex items-center gap-3">
            <div
              className={cx('h-10 w-10 rounded-full', icon.wrap)}
              style={{ background: 'var(--accent)' }}
              aria-hidden
            />
            <div>
              <div className={cx('text-lg', headingClasses(theme, 'h5'))}>
                Seu Microsite
              </div>
              <div className={cx('text-sm', mutedTextClasses())}>
                Powered by Elion
              </div>
            </div>
          </div>

          <nav className={cx('flex justify-center gap-6', mutedTextClasses())}>
            <a
              href={`/u/${siteHandle}/imoveis`}
              className="hover:text-[color:var(--text)]"
            >
              Imóveis
            </a>
            <a
              href={`/u/${siteHandle}/quem-sou-eu`}
              className="hover:text-[color:var(--text)]"
            >
              Quem sou eu?
            </a>
          </nav>

          <div className="flex md:justify-end items-center gap-4">
            {wa && ownerWhatsUrl && (
              <a
                href={ownerWhatsUrl}
                target="_blank"
                rel="noreferrer"
                className={cx(
                  'inline-flex items-center gap-2 font-semibold',
                  linkClasses(theme)
                )}
              >
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M.5 23.5l1.9-7A10 10 0 1112 22a10.2 10.2 0 01-5.1-1.4L.5 23.5z"
                  />
                </svg>
                {wa}
              </a>
            )}
          </div>
        </div>

        <div className={cx('mt-8 text-center text-sm', mutedTextClasses())}>
          © {new Date().getFullYear()} Seu Microsite. Todos os direitos
          reservados.
        </div>
      </div>
    </footer>
  );
}
